// src/components/Home/CrmFunnelWidget.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";

const CrmFunnelWidget = ({ crmSummary }) => {
  const navigate = useNavigate();

  if (!crmSummary) {
    return (
      <div className="dashboard-widget">
        < FullScreenLoader message="Carregando CRM..." />
      </div>
    );
  }

  const handleStageClick = (stageId) => {
    navigate(`/crm?stage=${stageId}`);
  };

  return (
    <div className="dashboard-widget">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        <h3 style={{ margin: 0 }}>Fúnil CRM</h3>
        <span style={{ fontSize: "24px", fontWeight: "bold", color: "#3498db" }}>
          {crmSummary.total_leads}
        </span>
      </div>

      <p style={{ color: "#7f8c8d", fontSize: "14px", marginBottom: "15px" }}>
        {crmSummary.leads_today} novos leads hoje
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {crmSummary.stages && crmSummary.stages.map((stage) => (
          <div
            key={stage.id}
            onClick={() => handleStageClick(stage.id)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              background: "var(--bg-tertiary",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#e9ecef";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#f8f9fa";
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: stage.color,
                }}
              />
              <span style={{ fontSize: "14px", fontWeight: "500" }}>{stage.name}</span>
            </div>
            <span style={{ fontSize: "16px", fontWeight: "bold", color: "#2c3e50" }}>
              {stage.count}
            </span>
          </div>
        ))}
      </div>

      <button
        onClick={() => navigate("/crm")}
        style={{
          marginTop: "15px",
          width: "100%",
          padding: "8px",
          background: "transparent",
          border: "1px solid #3498db",
          borderRadius: "4px",
          color: "#3498db",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        Ver todos Leads →
      </button>
    </div>
  );
};

export default CrmFunnelWidget;
